export default "__VITE_ASSET__sb529fFT__"